module.exports = __webpack_public_path__ + "img/pc-question.7693c876.svg";